import React, { useEffect } from "react";
import LoadingElement from "@/Components/Loading/LoadingElement";
import { useTranslation } from "@/Utils/CustomHooks/useTranslation";

interface TranslationGateProps {
    translationList: any;
    prefix: string;
    children: React.ReactNode;
}

export default function TranslationGate({
                                            translationList,
                                            prefix,
                                            children,
                                        }: TranslationGateProps) {
    const { prefixLoaded, addTranslations } = useTranslation();

    useEffect(() => {
        if (
            translationList?.translations &&
            !prefixLoaded(prefix)
        ) {
            addTranslations(translationList);
        }
    }, [translationList, prefix, prefixLoaded, addTranslations]);

    if (
        translationList?.translations &&
        !prefixLoaded(prefix)
    ) {
        return <LoadingElement />;
    }

    return <>{children}</>;
}